<script>
'use strict';

const ProductFilters = require('./ProductFilters.vue');
const ProductList = require('./ProductList.vue');
const StoryList = require('./StoryList.vue');
const SkeletonProductCard = require('./SkeletonProductCard.vue');
const SkeletonStoryCard = require('./SkeletonStoryCard.vue');

const PRODUCT_CARD_COUNT = 9;
const STORY_CARD_COUNT = 5;

module.exports = {
  name: 'ProductsSection',
  components: {
    ProductFilters,
    ProductList,
    StoryList,
    SkeletonProductCard,
    SkeletonStoryCard,
  },
  data() {
    return {
      productCount: PRODUCT_CARD_COUNT,
      storyCount: STORY_CARD_COUNT,
    };
  },
  computed: {
    stories() {
      return this.$store.state.storyResults;
    },
    loading() {
      return this.$store.state.loading;
    },
  },
};
</script>

<template>
  <div class="products-section">
    <div class="primary-column">
      <ProductFilters />
      <div class="product-list" v-if="loading" aria-busy="true">
        <SkeletonProductCard v-for="n in productCount" :key="n" />
      </div>
      <ProductList v-else actionLink="load more" />
    </div>
    <div class="secondary-column">
      <div class="top-story-results">
        <div class="skeleton-line skeleton-line-heading skeleton-pulse" v-if="loading"></div>
        <div class="top-story-results-heading" v-else>
          <span>Top <strong>Story</strong> Results</span>
        </div>
        <div class="story-list" v-if="loading">
          <SkeletonStoryCard v-for="n in storyCount" :key="n" />
        </div>
        <StoryList v-else :stories="stories" context="products-sidebar" :limit="7" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss"></style>
